import { configureStore } from '@reduxjs/toolkit';

import authSlice from './auth/auth-slice';
import userSlice from './users/user-slice';
import skillSlice from './skills/skill-slice';
import skillLevelSlice from './skills/skilllevel-slice';
import skillGroupSlice from './skillGroups/skillGroup-slice';
import groupSlice from './groups/group-slice';
import groupMemberSlice from './groups/groupmember-slice';
import notificationSlice from './notification/notification-slice';
import queueSlice from './queues/queue-slice';
import loadingSlice from './spinner/spinner-slice';
import queueMemberSlice from './queues/queue-member-slice';
import filterSlice from './filters/filter-slice';
import teamSlice from './teams/team-slice';
import divisionSlice from './divisions/division-slice';
import skillScheduleSlice from './skillSchedules/skillSchedule-slice';

const store = configureStore({
  reducer: { 
      auth: authSlice.reducer, 
      users: userSlice.reducer, 
      filters: filterSlice.reducer,
      skills: skillSlice.reducer,
      queues: queueSlice.reducer,
      groups: groupSlice.reducer,
      groupMembers: groupMemberSlice.reducer,
      skillLevels: skillLevelSlice.reducer,
      skillGroups: skillGroupSlice.reducer,
      queueMembers: queueMemberSlice.reducer,
      notification: notificationSlice.reducer,
      loading: loadingSlice.reducer, 
      teams: teamSlice.reducer, 
      divisions: divisionSlice.reducer,
      skillSchedules: skillScheduleSlice.reducer
    },  
});

export default store;